import { connect } from 'react-redux'
import { useEffect, useState } from 'react'
import { arrangeDiffsByNodes, changeTypes } from '../helpers'
import { Col, Row, List } from 'antd'
import Changes from './Changes'
import { PlusSquareOutlined, RightSquareOutlined, MinusSquareOutlined } from '@ant-design/icons'
import './Changelist.scss'

Changelist = ({ changes, source, target }) ->

  [diffList, setDiffList] = useState([])
  [activeNode, setActiveNode] = useState(undefined)

  useEffect( ->
    ( ->
      setDiffList(
        arrangeDiffsByNodes(
          changes or await Weaver.Branch.diffBranches(new Weaver.Branch(target), new Weaver.Branch(source))
        )
      )
      setActiveNode(undefined)
      undefined
    )()
    undefined
  , [source, target])

  getChangeIcon = (type) ->
    style = { marginRight: 5, color: 'white' }
    if type is changeTypes.CREATED
      style.background = '#13892c'
      <PlusSquareOutlined style={style} />
    else if type is changeTypes.UPDATED
      style.background = '#f6c342'
      <RightSquareOutlined style={style} />
    else if type is changeTypes.REMOVED
      style.background = '#d04437'
      <MinusSquareOutlined style={style} />

  <>
    <Row>
    <Col span={12} style={{ borderRight: '1px solid var(--borderColor)', height: '100%', textAlign: 'left' }}>
      <List
        size="small"
        dataSource={_.map(diffList, (val, key) -> { val..., key })}
        style={{ height: '100%', overflow: 'auto' }}
        renderItem={(item) ->
          <List.Item
            onClick={-> setActiveNode(item.key)}
            style={{
              (if item.key is activeNode
                {
                  fontWeight: 400,
                  background: '#58bd91'
                  color: 'white'
                }
              else
                {}
              )...
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
              cursor: 'pointer'
            }}
          >{ getChangeIcon(item.type) }{ item.key }
          </List.Item>
          }
        />
      </Col>
      <Col span={12} style={{ height: '100%', textAlign: 'left' }}>
        { if activeNode then <Changes nodeId={activeNode} diffs={diffList[activeNode]}/> }
      </Col>
    </Row>
  </>

export default Changelist
